import React, { useState, useEffect, useMemo } from 'react'
import { useParams, Link } from "react-router-dom"
import Pagination from '../pages/paginations'
import axios from "axios"
import Nav from './Nav'
import Table from './Table'

const View = () => {
    const { kategori } = useParams()
    const [key, setKey] = useState("")
    const [periode, setPeriode] = useState("")
    const [tahun, setTahun] = useState("")
    const [triwulan, setTriwulan] = useState("")
    const [bulan, setBulan] = useState("")
    const [minggu, setMinggu] = useState("")
    const [tanggal, setTanggal] = useState("")

    // State Display Filter
    const [optTahun, setOptTahun] = useState({ display: "none" })
    const [optTriwulan, setOptTriwulan] = useState({ display: "none" })
    const [optBulan, setOptBulan] = useState({ display: "none" })
    const [optMinggu, setOptMinggu] = useState({ display: "none" })
    const [optTanggal, setOptTanggal] = useState({ display: "none" })

    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(10)

    // Memoize formatted text biar gak berat
    const formattedKategori = kategori.replaceAll('-', ' ').toUpperCase()

    useEffect(() => {
        setData([])
        setCurrentPage(1)

        // Auto-setup kalau TJSL
        if (kategori === 'realisasi-tjsl') {
            setPeriode('TAHUN')
            getWaktu('TAHUN') // Biar input tahunnya langsung "display: block"
        } else {
            setPeriode('')
            getWaktu('') // Reset filter kalau pindah ke laporan lain
        }

        getData(kategori)
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }, [kategori])

    const getAvailableOptions = (firstData) => {
        if (!firstData || !firstData.periode) return listPeriodeLaporan // Fallback ke semua kalau data kosong

        const p = firstData.periode.toUpperCase()
        const options = []

        // Cek satu-satu kandungannya
        if (p.includes("TAHUN")) options.push({ value: "TAHUN", label: "1. TAHUN" })
        if (p.includes("TRIWULAN")) options.push({ value: "TRIWULAN", label: "2. TRIWULAN" })
        if (p.includes("BULAN")) options.push({ value: "BULAN", label: "3. BULAN" })
        if (p.includes("MINGGU")) options.push({ value: "MINGGU", label: "4. MINGGU" })
        if (p.includes("TANGGAL") || p.match(/\d{4}-\d{2}-\d{2}/)) options.push({ value: "TANGGAL", label: "5. TANGGAL" })

        // Kalau ternyata data pertama cuma "JANUARI 2024" (tanpa kata BULAN)
        // Kita tetep tambahin TAHUN dan BULAN sebagai standar minimal
        if (options.length === 0) return listPeriodeLaporan

        return options
    }

    const listPeriodeLaporan = [
        { value: "TAHUN", label: "1. TAHUN" },
        { value: "TRIWULAN", label: "2. TRIWULAN" },
        { value: "BULAN", label: "3. BULAN" },
        { value: "MINGGU", label: "4. MINGGU" },
        { value: "TANGGAL", label: "5. TANGGAL" },
    ]

    // REFACTOR: Logic Visibility Filter yang lebih rapi
    const getWaktu = (value) => {
        const reset = { display: "none" }
        const active = { display: "block" }

        // Default semua tutup
        setOptTahun(reset)
        setOptTriwulan(reset)
        setOptBulan(reset)
        setOptMinggu(reset)
        setOptTanggal(reset)

        // Buka sesuai pilihan
        if (value === 'TANGGAL') {
            setOptTanggal(active)
        } else if (value === 'MINGGU') {
            setOptTahun(active)
            setOptBulan(active)
            setOptMinggu(active)
        } else if (value === 'TRIWULAN') {
            setOptTahun(active)
            setOptTriwulan(active)
        } else if (value === 'BULAN') {
            setOptTahun(active)
            setOptBulan(active)
        } else if (value === 'TAHUN') {
            setOptTahun(active)
        }
        setPeriode(value)
    }

    const getData = async (value) => {
        let inputWaktu = ""
        if (periode === 'TANGGAL') inputWaktu = tanggal
        else if (periode === 'MINGGU') inputWaktu = `TAHUN ${tahun} BULAN ${bulan} MINGGU KE-${minggu}`
        else if (periode === 'TRIWULAN') inputWaktu = `TAHUN ${tahun} TRIWULAN ${triwulan}`
        else if (periode === 'BULAN') inputWaktu = `TAHUN ${tahun} BULAN ${bulan}`
        else if (periode === 'TAHUN') inputWaktu = `TAHUN ${tahun}`

        const slug = value || kategori
        const category = slug.replaceAll('-', ' ')

        try {
            let response
            if (slug === 'realisasi-tjsl') {
                response = await axios.get("/api/csr/portal/list", {
                    params: {
                        key: key,
                        tahun: tahun // State tahun yang diisi user di input box
                    }
                })
            } else {
                const payload = { subjek: category, key, waktu: inputWaktu, jml: 100 }
                response = await axios.post("/api/laporan/publish", payload)
            }

            const result = response.data.data || response.data

            // Reset fields
            setPeriode('')
            setTahun('')
            setTriwulan('')
            setBulan('')
            setMinggu('')
            setTanggal('')
            setKey('')
            setData(result)
            setCurrentPage(1)
        } catch (err) {
            console.error("Gagal tarik data:", err)
        }
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        return !data ? [] : data.slice(firstPageIndex, firstPageIndex + PageSize)
    }, [data, currentPage, PageSize])

    return (
        <header className="ms-hero-page-override-home no-mt pb-4">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-slash">
                        <li className="breadcrumb-item">
                            <Link to={'/'} className="btn btn-raised btn-primary br-2 no-m">BERANDA</Link>
                        </li>
                        <li className="breadcrumb-item active">LAPORAN</li>
                        <li className="breadcrumb-item active">{formattedKategori}</li>
                    </ol>
                    <div className="btn-group w-300">
                        <button type="button" className="btn btn-warning btn-raised dropdown-toggle" data-toggle="dropdown">
                            {formattedKategori} <i className="zmdi zmdi-chevron-down right only"></i>
                        </button>
                        <Nav getKategori={getData} />
                    </div>
                </nav>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <h1 className='color-dark font-bold lh-125'>LAPORAN {formattedKategori}</h1>
                        <h3 className="color-dark lh-125">Telusuri laporan {formattedKategori.toLowerCase()} Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu Kota Bekasi</h3>
                        <hr />

                        <div className="row">
                            <div className="col-md-3">
                                <input className="form-control" type="text" value={key} onChange={(e) => setKey(e.target.value)} placeholder="Masukkan Kata Kunci" />
                            </div>
                            <div className="col-sm-2">
                                <select className="form-control" value={periode} onChange={(e) => getWaktu(e.target.value)} required>
                                    <option value="">=Periode=</option>
                                    {kategori === 'realisasi-tjsl' ? (
                                        <option value="TAHUN">TAHUN</option>
                                    ) : (
                                        // Pakai data pertama buat filter list pilihannya
                                        getAvailableOptions(data[0]).map((p) => (
                                            <option key={p.value} value={p.value}>{p.label}</option>
                                        ))
                                    )}
                                </select>
                            </div>

                            {/* Filter Waktu Dinamis */}
                            <div className="col-md-2" style={optTahun}>
                                <input className="form-control" type="text" value={tahun} onChange={(e) => setTahun(e.target.value)} placeholder="Tahun" />
                            </div>
                            <div className="col-md-2" style={optTriwulan}>
                                <select className="form-control" value={triwulan} onChange={(e) => setTriwulan(e.target.value)} >
                                    <option value="">=Triwulan=</option>
                                    <option value="I">1. SATU</option>
                                    <option value="II">2. DUA</option>
                                    <option value="III">3. TIGA</option>
                                    <option value="IV">4. EMPAT</option>
                                </select>
                            </div>
                            <div className="col-md-2" style={optBulan}>
                                <select className="form-control" value={bulan} onChange={(e) => setBulan(e.target.value)} >
                                    <option value="">=Bulan=</option>
                                    {["JANUARI", "FEBRUARI", "MARET", "APRIL", "MEI", "JUNI", "JULI", "AGUSTUS", "SEPTEMBER", "OKTOBER", "NOVEMBER", "DESEMBER"].map((bln, i) => (
                                        <option key={bln} value={bln}>{i + 1}. {bln}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-2" style={optMinggu}>
                                <select className="form-control" value={minggu} onChange={(e) => setMinggu(e.target.value)} >
                                    <option value="">=Minggu Ke-=</option>
                                    <option value="1">1. SATU</option>
                                    <option value="2">2. DUA</option>
                                    <option value="3">3. TIGA</option>
                                    <option value="4">4. EMPAT</option>
                                </select>
                            </div>
                            <div className="col-md-2" style={optTanggal}>
                                <input className="form-control" type="date" value={tanggal} onChange={(e) => setTanggal(e.target.value)} />
                            </div>

                            <div className="col-md-1">
                                <button className="btn btn-raised btn-primary br-2 no-m" onClick={() => getData()}>
                                    <i className="fa fa-search no-m"></i>
                                </button>
                            </div>
                        </div>

                        <Table
                            tableData={tableData}
                            isCsr={kategori === 'realisasi-tjsl'}
                        />

                        <div className="text-center p-4">
                            <Pagination
                                currentPage={currentPage}
                                totalCount={data.length}
                                pageSize={PageSize}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default View